import { useAppSelector } from '@app/redux/hooks';
import dynamic from 'next/dynamic';

import styles from './HeaderDesktop.module.scss';

const HeaderMain = dynamic(() => import('@app/Layout/Header/Desktop/HeaderMain'));
const HeaderPartner = dynamic(() => import('@app/Layout/Header/Desktop/HeaderPartner'));

const DesktopHeader = () => {
  const { regionPartner } = useAppSelector(state => state.header.data);
  return <header className={styles.HeaderDesktop}>{regionPartner ? <HeaderPartner /> : <HeaderMain />}</header>;
};

export default DesktopHeader;
